import { render, staticRenderFns } from "./GroupHistoryPerformance.vue?vue&type=template&id=1afcc6cf&scoped=true&"
import script from "./GroupHistoryPerformance.vue?vue&type=script&lang=ts&"
export * from "./GroupHistoryPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcc6cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
